"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _exportLog = require("@/api/log/exportLog");
var _index = require("@/utils/index");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'exportLog',
  data: function data() {
    return {
      // 搜索表单
      searchForm: {
        operator: '',
        timeRange: []
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页
      currentPage: 1,
      pageSize: 10,
      total: 0
    };
  },
  methods: {
    // 搜索
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchTableData();
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.searchForm = {
        operator: '',
        timeRange: []
      };
      this.handleSearch();
    },
    // 获取表格数据
    fetchTableData: function () {
      var _fetchTableData = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              params = {
                page: this.currentPage,
                limit: this.pageSize,
                createBy: this.searchForm.operator
              }; // 处理时间范围
              if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                params.startDate = this.searchForm.timeRange[0];
                params.endDate = this.searchForm.timeRange[1];
              }
              _context.next = 2;
              return (0, _exportLog.getExportLogList)(params);
            case 2:
              response = _context.sent;
              if (response && response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.tableData = [];
                this.total = 0;
                this.$message.error(response.message || '获取导出日志失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              console.error('获取导出日志失败:', _t);
              this.$message.error('获取导出日志失败');
              this.tableData = [];
              this.total = 0;
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchTableData() {
        return _fetchTableData.apply(this, arguments);
      }
      return fetchTableData;
    }(),
    // 下载文件
    handleDownload: function handleDownload(row) {
      if (row.fileName) {
        try {
          // 通过拼接URL来生成下载链接
          var downloadUrl = "".concat(process.env.VUE_APP_EXCEL_PATH, "/").concat(row.fileName);
          if (row.type === 2) {
            //2代表图片文件
            downloadUrl = "".concat(process.env.VUE_APP_IMAGE_PATH, "/").concat(row.fileName);
          }
          console.log('下载链接:', downloadUrl);
          window.open(downloadUrl, '_self');
        } catch (error) {
          console.error('下载失败:', error);
          this.$message.error('下载失败，请稍后重试');
        }
      } else {
        this.$message.warning('文件名不存在');
      }
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchTableData();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchTableData();
    },
    // 格式化时间戳
    formatTimestamp: function formatTimestamp(timestamp) {
      if (!timestamp) return '';
      var date = new Date(timestamp);
      return (0, _index.parseTime)(date, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取状态文本
    getStateText: function getStateText(state) {
      var stateMap = {
        0: '导出中',
        1: '导出成功',
        2: '导出失败'
      };
      return stateMap[state] || '未知';
    },
    // 获取状态标签类型
    getStateType: function getStateType(state) {
      var typeMap = {
        0: 'warning',
        1: 'success',
        2: 'danger'
      };
      return typeMap[state] || 'info';
    }
  },
  mounted: function mounted() {
    this.fetchTableData();
  }
};